import React from "react";
import { Link } from "react-router-dom";

import { workspaceNav } from "../../../routes/workspaceNavigation";
import type { WorkspaceId } from "../../../utils/workspaceStorage";
import { tabLabels, TabId } from "../types";

type Props = {
  tab: TabId;
  eventName: string;
  eventSubtitle: string;
  selectedEventId: string | null;
  clock: string;
  workspace: WorkspaceId;
};

export const EventOSTopbar: React.FC<Props> = ({ tab, eventName, eventSubtitle, selectedEventId, clock, workspace }) => (
  <header className="eventos-topbar">
    <div className="eventos-topbar-start">
      <div className="eventos-topbar-titles">
        <div className="eventos-topbar-title">{tabLabels[tab]}</div>
        <div className="eventos-topbar-context" title={`${eventName} - ${eventSubtitle}`}>
          <span className="eventos-topbar-context-main">{eventName}</span>
          <span className="eventos-topbar-context-sep">•</span>
          <span className="eventos-topbar-context-sub">{eventSubtitle}</span>
        </div>
      </div>
    </div>
    <div className="eventos-topbar-end">
      {selectedEventId ? (
        <Link
          to={workspaceNav.dashboard(workspace, selectedEventId)}
          className="eventos-nav-btn eventos-topbar-dashboard-link"
        >
          Dashboard
        </Link>
      ) : null}
      <Link to={workspaceNav.events(workspace)} className="eventos-nav-btn eventos-topbar-home-link">
        Events
      </Link>
      <Link to={workspaceNav.home(workspace)} className="eventos-nav-btn eventos-topbar-home-link">
        Home
      </Link>
      <div className="eventos-clock">{clock}</div>
    </div>
  </header>
);
